import React from 'react'
import { BText } from '@prague-digi/ui-components'

import { intl, IntlInterface } from '../../hoc'
import styles from './styles.scss'
import messages from '../../i18n'

interface Props extends IntlInterface {
  img2012: any
  text: any
}

export const DocumentInfoModal = ({ img2012, text, translate }: Props) => (
  <div className={styles.helpDialog}>
    <BText>{translate(text)}</BText>

    <img alt={translate(messages.documentInfoModal.id2012)} src={img2012} />
    <BText theme="mt-4">
      <b>{translate(messages.documentInfoModal.id2012)}</b>
    </BText>
  </div>
)

export default intl(DocumentInfoModal)
